<template>
  <div class="container">
    <h1>
      {{ $t('terms.headline')}}
    </h1>
    <p v-for="i in paragraphs" :key="i">
      {{ $t(`terms.p${i}`) }}
    </p>
    <p>
      <b>{{$t('terms.provider')}}:</b> <br>
      Folyo GmbH <br>
      Edelhofgasse 21/3 <br>
      1180 Wien <br>
      Österreich <br>
    </p>

    <p>
      <b>{{$t('terms.contact')}}:</b> <br>
      +43 664 423 30 36 <br>
      <a href="mailto:info@getfolyo.com">info@getfolyo.com</a>
    </p>
  </div>
</template>


<script>
export default {
  data () {
    return {
      paragraphs: [1, 2, 3]
    }
  },
  created () {
    this.$Progress.finish()
  }
}
</script>

<style lang="stylus">
.container
  max-width: 600px;
  margin: auto;
  padding: 2em;
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue